// @ts-nocheck
import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import {
    GetProductByIdApiV2Parameter,
    GetProductVariantChildApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadProduct from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import {
    createHandlerChainRunnerOptionalParameter,
    executeAwaitableHandlerChain,
    Handler,
} from "@toolkit/Modules/client-framework/HandlerCreator";

interface Parameter {
    productId?: string;
}

interface Props {
    apiParameter: GetProductByIdApiV2Parameter | GetProductVariantChildApiV2Parameter;
    variantChildren?: ProductModel[] | null;
    product?: ProductModel;
    productInfo?: ProductInfo;
    originalProduct?: ProductModel;
    originalProductInfo?: ProductInfo;
}

type HandlerType = Handler<Parameter, Props>;
export const DispatchBeginSetProduct: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/ScratchAndDentForm/BeginSetProduct",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    if (props.parameter.productId) {
        props.apiParameter = {
            id: props.parameter.productId,
            expand: ["detail", "variantTraits"],
        };
    }
};

export const RequestDataFromApi: HandlerType = async props => {
    const { apiParameter } = props;
    if (!apiParameter) {
        return;
    }

    props.product = await executeAwaitableHandlerChain(loadProduct, props.apiParameter, props);
    if (props.product?.properties.sndParentId) {
        props.originalProduct = await executeAwaitableHandlerChain(
            loadProduct,
            { id: props.product?.properties.sndParentId },
            props,
        );
    }
};

export const DispatchCompleteSetProduct: HandlerType = props => {
    const product = props.product;
    const originalProduct = props.originalProduct;

    if (!product) {
        return;
    }

    props.productInfo = createFromProduct(product);
    props.originalProductInfo = originalProduct ? createFromProduct(originalProduct) : undefined;
    props.dispatch({
        type: "Store/Components/ScratchAndDentForm/CompleteSetProduct",
        productInfo: props.productInfo,
        originalProductInfo: props.originalProductInfo,
    });
};

export const chain = [DispatchBeginSetProduct, PopulateApiParameter, RequestDataFromApi, DispatchCompleteSetProduct];

const setProduct = createHandlerChainRunnerOptionalParameter(chain, {}, "SetProduct");
export default setProduct;
